import SelectPicker from 'rsuite/SelectPicker';
import 'rsuite/SelectPicker/styles/index.css';

//-- forma_pago": (TR | DE | EF | CO | TE | CH),
export default function FormaDePago({
    formik,
}){
    const data = [
        {
            valor: "TR",
            descripcion: "Transferencia"
        },
        {
            valor: "DE",
            descripcion: "Deposito"
        },
        {
            valor: "EF",
            descripcion: "Efectivo"
        },
        {
            valor: "CO",
            descripcion: "Conveniencia"
        },
        {
            valor: "TE",
            descripcion: "Terminal"
        },
        {
            valor: "CH",
            descripcion: "Cheque"
        },
    ]
    return(
    <>
        <style type={'text/css'}>
            {`
                    #forma_pago{
                        background-color : var(--bs-gray-100)!important;
                        border: 0!important;
                    }
                    
                    #forma_pago > .rs-stack{
                        display : block!important;
                    }                      
                    #forma_pago-label{
                        display : flex!important;
                    }
                    .labelSelect {
                        font-size : 1rem;
                        color: rgba(var(--bs-body-color-rgb),.65);
                        transform: scale(.85) translateY(-.5rem) translateX(.15rem);
                        position : absolute;
                        left : 0;
                    }
                    #forma_pago > .rs-stack > div:nth-child(2){
                        padding-top : 1.25rem;
                        text-transform:uppercase!important;
                        padding-left : 0.25rem!important;
                    }
                    
                    #forma_pago-listbox > div > span.rs-picker-select-menu-item-active{
                        color : var(--bs-component-hover-color);
                    }
                    
                    #forma_pago-listbox > div > span.rs-picker-select-menu-item-active::after{
                        background-color: var(--bs-component-hover-color);
                        content: "";
                        display: block;
                        height: .75rem;
                        -webkit-mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'%3E%3Cpath fill='var(--bs-component-hover-color)' d='M4.896 6.498 2.795 4.265A1.33 1.33 0 0 0 .857 6.088l3.893 4.138a1 1 0 0 0 1.457 0l6.936-7.373a1.33 1.33 0 0 0-1.938-1.823L6.061 6.498a.8.8 0 0 1-1.165 0'/%3E%3C/svg%3E");
                        mask-position: center;
                        -webkit-mask-position: center;
                        mask-repeat: no-repeat;
                        -webkit-mask-repeat: no-repeat;
                        width: .75rem;
                    }
                    
                    #forma_pago-listbox > div > span.rs-picker-select-menu-item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        text-transform:uppercase!important;
                    }
                    .rs-picker-toggle-label::after {
                        display : none!important;
                    }
                    
                `}
        </style>
        <SelectPicker
            label={<div className={'labelSelect ps-2'}>Forma de pago:</div>}
            data={data}
            style={{width: "100%"}}
            menuStyle={{width: 'auto'}}
            id={'forma_pago'}
            name={'forma_pago'}
            labelKey={'descripcion'}
            valueKey={'valor'}
            value={formik.values.forma_pago}
            onChange={(value) => formik.setFieldValue('forma_pago', value)}
            onBlur={formik.handleBlur}
            searchable={false}
            cleanable={false}
            disabled={formik.values.movimiento === "G"}
        />
    </>
    );
}
